import React from 'react';
import { Container, Row } from 'reactstrap';
import AccountSettingPage from './components/AccountSettingPage';
import PageHeader from '../../../../shared/components/PageHeader';

const AccountSetting = () => (
  <Container>
    <Row>
      <PageHeader title="Account Setting" subhead="Use Account Selector to choose the setting you want to manage." />
    </Row>
    <Row>
      <AccountSettingPage />
    </Row>
  </Container>
);

export default AccountSetting;

